module.exports = __webpack_public_path__ + "static/media/cx.172a41ec.svg";